import BaseDrawer from "../../../utils/map/BaseDrawer";
import {OBJECT} from "../../../utils/map/types";
import 'leaflet'

class CarDrawer extends BaseDrawer{

  constructor (map, vm, options) {
    super(map, vm, options)
    this.routeLayer = L.featureGroup()
    this.routeLayer.addTo(map)
    this.allCarMarkers = {}
  }

  cleanAllMarkers () {
    for (let id in this.allCarMarkers) {
      this.allCarMarkers[id].remove()
    }
    this.allCarMarkers = {}
  }

  drawAllCarMarkers (markersModel = [], opts = {}) {
    markersModel.forEach(m => {
      let id = m.id
      if (!this.allCarMarkers[id]) {
        this.allCarMarkers[id] = this.drawMarker(m, opts)
      } else {
        let newLatLng = new L.LatLng(m.lat, m.lng)
        this.allCarMarkers[id].setLatLng(newLatLng)
        if (this.allCarMarkers[id]._popup) {
          this.allCarMarkers[id]._popup.vueEl.fields = Object.assign({}, m)
        }
        if (this.allCarMarkers[id].options.icon.vueEl) {
          this.allCarMarkers[id].options.icon.vueEl.fields = Object.assign({}, m)
        }
      }
    })
  }

  routeExist () {
    return this.routeLayer.getLayers().length > 1
  }

  onMarkerClick (e, marker) {
    const routeExist = this.routeExist()
    this.$emitter.emit('marker.click', {
      marker,
      e,
      routeExist
    })
    if (routeExist && marker.options.model.type === OBJECT.CAR) {
      this.createPopup(marker)
    }
  }

  removeCarRoute () {
    if (this.routeLayer) {
      this.routeLayer.clearLayers()
    }
  }

  drawCarRoute (inputCar, options) {
    this.removeCarRoute()
    let car = this.dropVueWatchers(inputCar)
    let {nearWearIndex = null} = car
    if (nearWearIndex !== null) {
      this.drawCarRouteLineWithPointCompare(car, car.routeData, options)
    } else {
      this.drawCarRouteLine(car, car.routeData, options)
    }
    this.drawCarRouteWaypoints(car, car.routeData, options)
  }

  drawCarRouteWaypoints (car, routeData = {}, options = {}) {
    let {markerType = OBJECT.CIRCLE} = options
    if (routeData.waypointIndices && routeData.waypointIndices.length > 0) {
      routeData.instructions.forEach(v => {
        if (routeData.waypointIndices.indexOf(v.index) > -1) {
          let model = Object.assign(v, {
            lat: routeData.coordinates[v.index][0],
            lng: routeData.coordinates[v.index][1],
            id: `car${car.id}_index${v.index}`,
            type: markerType
          })
          this.drawMarker(model, {attachToLayer: this.routeLayer})
            .bindTooltip(`${v.road || ''}`)
        }
      })
    }
  }

  drawRouteLayer (car, passedRoute, upcomingRoute, options = {}) {
    if (passedRoute.length > 0) {
      this.routeLayer.addLayer(new L.polyline(passedRoute, {
        color: 'red',
        weight: 3,
        opacity: 0.5,
        smoothFactor: 1
      }))
    }
    if (upcomingRoute.length > 0) {
      this.routeLayer.addLayer(new L.polyline(upcomingRoute, {
        color: 'blue',
        weight: 3,
        opacity: 0.5,
        smoothFactor: 1
      }))
    }
    this.routeLayer.addTo(this._map)
    if (!options.disableFitToBounds) {
      this._map.fitBounds(
        this.routeLayer.getBounds()
      )
    }
  }

  drawCarRouteLineWithPointCompare (car, routeData = {}, options = {}) {
    let {disableColorize = false} = options
    if (routeData.coordinates && routeData.coordinates.length > 0) {
      let passedRoute = []
      let upcomingRoute = []
      let pushToUpcoming = false
      if (disableColorize === true) {
        routeData.coordinates.forEach(v => {
          upcomingRoute.push(L.latLng(v))
        })
      } else {
        routeData.coordinates.forEach((v, index) => {
          if (pushToUpcoming === false && index == car.nearWearIndex) {
            pushToUpcoming = true
            passedRoute.push(L.latLng(v))
          }
          if (pushToUpcoming === true) {
            upcomingRoute.push(L.latLng(v))
          } else {
            passedRoute.push(L.latLng(v))
          }
        })
      }
      this.drawRouteLayer(car, passedRoute, upcomingRoute, options)
    }
  }

  drawCarRouteLine (car, routeData = {}, options = {}) {
    let {disableColorize = false} = options
    if (routeData.coordinates && routeData.coordinates.length > 0) {
      let passedRoute = []
      let upcomingRoute = []
      let pushToUpcoming = false
      if (disableColorize === true) {
        routeData.coordinates.forEach(v => {
          upcomingRoute.push(L.latLng(v))
        })
      } else {
        routeData.coordinates.forEach(v => {
          if (pushToUpcoming === false && this.isNearWear({
            lat: v[0],
            lng: v[1]
          }, {
            lat: car.lat,
            lng: car.lng
          })) {
            pushToUpcoming = true
            passedRoute.push(L.latLng(v))
          }
          if (pushToUpcoming === true) {
            upcomingRoute.push(L.latLng(v))
          } else {
            passedRoute.push(L.latLng(v))
          }
        })
      }
      this.drawRouteLayer(car, passedRoute, upcomingRoute, options)
    }
  }
}

export default CarDrawer
